import { api } from "./apiClient";
import { redirectToOauthFlow } from "./navUtils";
import { ACCESS_TOKEN_KEY } from "./session";

export const postscriptUrl = process.env.REACT_APP_POSTSCRIPT_API_URL;

const request = (method, route, body) => {
  // Missing access token indicates that re-authentication is required
  if (!localStorage.getItem(ACCESS_TOKEN_KEY)) {
    return redirectToOauthFlow();
  }
  return api[method](`${postscriptUrl}${route}`, { body });
};

const psClient = {
  get: (route) => request("get", route),
  post: (route, body) => request("post", route, body),
  put: (route, body) => request("put", route, body),
  delete: (route) => request("delete", route),
};

export default psClient;
